import { render } from "./ModalProfessionals.vue?vue&type=template&id=4c5e8704"
import script from "./ModalProfessionals.vue?vue&type=script&lang=js"
export * from "./ModalProfessionals.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__